// Focus de la séquence d'accueil, hors du composant pour rester testable seul.

/**
 * À la fermeture : l'élément d'avant s'il est encore à l'écran (pas un article de menu disparu), sinon `fallback`
 * (le bouton du menu du compte), sinon le contenu principal, sinon rien.
 */
export const restoreFocus = (before: HTMLElement | null, fallback: HTMLElement | null) => {
  const usable = (el: HTMLElement | null): el is HTMLElement =>
    !!el && el.isConnected && el !== document.body && el.getClientRects().length > 0;
  const target = [before, fallback].find(usable);
  if (target) return target.focus({ preventScroll: true });
  const main = document.getElementById("main-content");
  if (!main) return;
  if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1");
  main.focus({ preventScroll: true });
};
